import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import microFeedTitle from '../../components/microFeedTitle.vue';
import btnList from '../../components/btnList.vue';
import wxOpenButton from '../../../../components/wxOpenButton.vue';
import { mapGetters } from 'vuex';
import { isScreenOptimization } from '../../abtestConfig';
import { openUrlByOpenApi, appendParam } from '@baidu/map-fe-utils';
import { addPvNew, isBaiduMapAuto, isHarmony } from '../../../../utils';
export default {
  components: {
    microFeedTitle,
    btnList,
    wxOpenButton
  },
  props: {
    newBtnIcon: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    },
    microIndex: {
      type: Number,
      default: 0
    },
    jumpWxAppUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isBaiduMapAuto: isBaiduMapAuto(),
      isScreenOptimization,
      isHarmony: isHarmony()
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({
    buttonClass() {
      if (this.newBtnIcon && this.dataType !== 'poicomment') {
        return 'btn-user-info-new';
      }
      return 'btn-user-info';
    }
  }, mapGetters(['phoneInfo', 'cityId'])), mapGetters('url', ['dataType', 'abtest', 'urlParams'])), mapGetters('login', ['isLogin'])),
  methods: {
    // 跳转到地图
    jumpToMap() {
      this.$emit('open-Baidu-Map');
    },
    // todo分享逻辑已拆分，未合入
    updateWxShare(val) {
      this.$emit('open-share', val);
    },
    /**
     * 点击反馈跳转到投诉面板
     *
     * @returns {void}
     */
    handleReport(src, isForewarning, unique_id) {
      // 反馈点击埋点
      addPvNew(['MCEDse.NewMedia.detailspage.feedback.click'], {
        unique_id: unique_id,
        warningnote: isForewarning ? '1' : '0',
        source: 'pushnote'
      });
      const {
        course_id = '',
        stats_key = '',
        stats_sub_key = '',
        category = '',
        clicktype = '',
        source = ''
      } = this.urlParams;
      const originUrl = 'https://newclient.map.baidu.com/feed-h5/push-feedback';
      const newParams = {
        push_src_id: src,
        unique_id,
        course_id,
        stats_key,
        stats_sub_key,
        category,
        clicktype,
        source
      };
      const url = appendParam(originUrl, newParams);
      // 跳转到反馈页面
      openUrlByOpenApi(url);
    }
  }
};